// extracted by mini-css-extract-plugin
module.exports = {"ds-flex":"FlexContainer_ds-flex__7ecly","space-between":"FlexContainer_space-between__1Qbie"};